import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { OnboardingApiService } from '../../../../services/onboarding/onboarding-api.service';
import { MatPseudoCheckboxModule } from "@angular/material/core";
import { Segment } from '../../../../models/onboarding/onboarding.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../../../../components/confirmation-dialog/confirmation-dialog.component';
import { Title } from 'chart.js';

@Component({
  selector: 'app-onboarding-product-list',
  templateUrl: './onboarding-product-list.component.html',
  styleUrl: './onboarding-product-list.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatPseudoCheckboxModule,
    MatCheckboxModule,
    MatDialogModule
  ],
})
export class OnboardingProductListComponent {
  segments: Segment[] = [];
  selectedRegions: { [key: string]: string } = {};

  constructor(
    private onboardingApiService: OnboardingApiService,
    private readonly toastr: ToastrService,
    private dialog: MatDialog
  ) {
  }

  private openDialog(message: string, confluenceUrl?: string): void {
    this.dialog.open(ConfirmationDialogComponent, {
      width: '450px',
      data: {
        message,
        title: 'Access Request',
        confluenceUrl: confluenceUrl || undefined,
        okOnly: true
      },
      autoFocus: false
    });
  }

  private getConfluenceUrl(response: any): string | null {
    return response?.confluence_link || response?.confluence_url || response?.next_steps_url || response?.nextStepsUrl || null;
  }

  ngOnInit(): void {
    const msg = sessionStorage.getItem('onboarding_banner_message');
    if (msg) {
      const confluenceUrl = sessionStorage.getItem('onboarding_banner_confluence');
      sessionStorage.removeItem('onboarding_banner_message');
      sessionStorage.removeItem('onboarding_banner_confluence');
      this.openDialog(msg, confluenceUrl);
    }
    this.getSegments();
  }

  onRegionChange(businessUnitCode: string, region: string) {
    if (Array.isArray(region)) {
      region = region[0];
    }
    const regions = this.selectedRegions[businessUnitCode]
      ? this.selectedRegions[businessUnitCode].split(',')
      : [];

    const regionIndex = regions.indexOf(region);

    if (regionIndex === -1) {
      regions.push(region);
    } else {
      regions.splice(regionIndex, 1);
    }

    this.selectedRegions[businessUnitCode] = regions.join(',');
  }

  getRegionDisplayLabel(bu: any, selectedValue: string): string {
    if (!selectedValue) return 'Select';
    const names = selectedValue.split(',').filter(n => n);
    return names.map(n => {
      const region = bu.regions?.find((r: any) => r.name === n);
      return region?.label || n;
    }).join(', ');
  }

  getSegments() {
    this.onboardingApiService.getSegments().subscribe((segments: Segment[]) => {
      const filteredSegments = (segments || []).map(seg => ({
        ...seg,
        business_units: Array.isArray(seg.business_units) ? seg.business_units.filter(bu => !!bu.show_business_unit) : []
      }))
        .filter(seg => Array.isArray(seg.business_units) && seg.business_units.length > 0);

      this.segments = filteredSegments;
    });
  }


  onAccessRequest(businessUnitCode: string) {
    const businessUnit = this.segments
      .flatMap(segment => segment.business_units)
      .find(unit => unit.code === businessUnitCode);

    const isManualRequest = businessUnit?.is_manual_request || false;
    if (isManualRequest) {
      const wwid = sessionStorage.getItem('userId') || '';
      const user_name = sessionStorage.getItem('givenName') + ' ' + sessionStorage.getItem('surname');
      const user_email = sessionStorage.getItem('userEmail') || '';
      const region = this.selectedRegions[businessUnitCode];
      const business_unit_code = businessUnitCode;
      if (!region) {
        this.toastr.error('Please select a region before requesting access.');
        return;
      }
      this.onboardingApiService.raiseAccessRequest({
        wwid,
        user_name,
        user_email,
        region,
        business_unit_code,
        is_manual_request: isManualRequest
      }).subscribe(
        (response) => {
          this.openDialog(response.message || 'Your access request has been submitted.', this.getConfluenceUrl(response));
        },
        (error) => {
          this.toastr.error(error.error);
        }
      );
    } else {
      this.submitAccessRequest(businessUnitCode, isManualRequest);
    }
  }

  private submitAccessRequest(businessUnitCode: string, isManualRequest: boolean) {
    const wwid = sessionStorage.getItem('userId') || '';
    const user_name = sessionStorage.getItem('givenName') + ' ' + sessionStorage.getItem('surname');
    const user_email = sessionStorage.getItem('userEmail') || '';
    const region = this.selectedRegions[businessUnitCode];
    const business_unit_code = businessUnitCode;
    if (!region) {
      this.toastr.error('Please select a region before requesting access.');
      return;
    }
    this.onboardingApiService.raiseAccessRequest({
      wwid,
      user_name,
      user_email,
      region,
      business_unit_code,
      is_manual_request: isManualRequest
    }).subscribe(
      (response) => {
        this.openDialog(response.message || 'Your access request has been submitted.', this.getConfluenceUrl(response));
      },
      (error) => {
        this.toastr.error(error.error);
      }
    );
  }

}
